var map = {
	"./arrow-right-white.svg": "600a",
	"./arrow-right.svg": "55b9",
	"./bubble.svg": "24a0",
	"./carton.svg": "7314",
	"./click-save.svg": "b0be",
	"./completed.svg": "a018",
	"./crown-brown.svg": "0479",
	"./crown-grey.svg": "782c",
	"./crown-yellow.svg": "8a8f",
	"./flower.svg": "147d",
	"./gongyi-en.svg": "043a",
	"./gongyi.svg": "4c40",
	"./love-99.svg": "bbc1",
	"./love-left-99.svg": "2a9e",
	"./love-left.svg": "3936",
	"./love-right-99.svg": "5c7e",
	"./love-right.svg": "b85a",
	"./love.svg": "66fc",
	"./tnc.svg": "6d8f",
	"./uncompleted.svg": "2daf",
	"./wechatpay.svg": "2af8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "23f1";